export const dateTimeCellStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
};
